<template>
  <ul class="mb-4 list-group" v-if="timesData">
    <li v-for="day in Object.keys(timesData)" :key="day" class="col-12 d-flex align-items-center list-group-item px-0">
        <div class="col-2 ">{{ $t(capitalize(day)) }}</div>
        <div class="col-8 d-flex flex-column flex-lg-row justify-content-center">
          <TimeSlot v-for="timeSlot in [0, 1]"
                    class="ml-4"
                    :value="timesData[day][timeSlot]"
                    @update:value="handleTimeChange(day, timeSlot, $event)"
          >
          </TimeSlot>
          <input type="hidden" :name="`${inputName}[${day}][0]`" :value="timesData[day][0]">
          <input type="hidden" :name="`${inputName}[${day}][1]`" :value="timesData[day][1]">
        </div>
        <div class="col-2 d-flex justify-content-center">
          <button type="button" v-if="day === 'monday'"
                  @click="duplicateMonday()"
                  class="btn btn-outline-primary btn-sm">
            <i class="fa fa-clone" style="width: 25px"></i>
          </button>
        </div>
      </li>
    </ul>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from "vue";
import TimeSlot from "@/components/store/TimeSlot.vue";
import { DAYS } from "@/utils/date";

const props = defineProps(
  {
    timesData: {
      type: Object,
      default: () => {}
    },
    inputName: String
  });
const emit = defineEmits(["time-changed"]);

const timesData = ref(props.timesData)

// add watch to timesData
watch(() => props.timesData, (newValue) => {
  timesData.value = newValue;
});


function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function duplicateMonday() {
  const monday = timesData.value['monday'];

  emit("time-changed", {
    ... DAYS.reduce((accumulator, day) => {
      accumulator[day] = [...monday]
      return accumulator;
    }, {})
  })
}

const handleTimeChange = (day, slot, value) => {
  emit("time-changed", {
    ...timesData.value,
    [day]: [
      ...timesData.value[day].slice(0, slot),
      value,
      ...timesData.value[day].slice(slot + 1)
    ]
  });
};

</script>

<style scoped>

</style>
